"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineHeight = exports.fontSize = void 0;
exports.fontSize = {
    sm: 12,
    md: 14,
    lg: 16,
};
exports.lineHeight = {
    sm: 16,
    md: 18,
    lg: 21,
};
